export const offers = {
  appBarTitle: "Offers",
  addOffer: "Add New Offer",
  deleteOffer: "Delete offer",
  deleteConfirm:
    "Are you sure you want to delete this offer? This action cannot be undone.",
  publishOffer: "Publish offer",
  publishConfirm:
    "Publishing an offer will display it for the consumers. Are you sure you want to publish this offer?",
  unpublishOffer: "Unpublish offer",
  unpublishConfirm:
    "Unpublishing an offer will hide it from the consumers’ side. Are you sure you want to unpublish this offer?",
  markAsServiceOffer: "Mark as Service Offer",
  markAsServiceOfferConfirm: "Are you sure you want to mark this offer as a service offer?",
  removeServiceOffer: "Remove Service Offer",
  removeServiceOfferConfirm: "Are you sure you want to remove the service offer status?",
  noOffers: "No offers yet",
  offersPerPage: "Offers per page",
  on: "On",
  off: "Off",
  card: {
    view: "View",
    edit: "Edit",
    delete: "Delete",
    pending: "Pending",
    started: "Started",
    expired: "Expired",
    starts: "Starts",
    ends: "Ends",
    templateLabel: "Offer may be available for multi partners",
    editOfferTooltip: "Expired offers can’t be edited",
    published: "Published",
    unpublished: "Unpublished",
    publish: "Publish",
    unpublish: "Unpublish",
    serviceOffer: "Service Offer",
  },
  filters: {
    startDate: "Start Date",
    endDate: "End Date",
    status: "Status",
    pending: "Pending",
    started: "Started",
    expired: "Expired",
    carMake: "Vehicle Brand",
    carType: "Vehicle Type",
  },
  offerForm: {
    createTitle: "Create Offer",
    editTitle: "Edit Offer",
    create: "Create",
    edit: "Edit",
    offerBanner: "Upload Banner",
    hotOfferBanner: "Upload Hot Offer Banner",
    hotOfferToggle: "Hot Offer",
    serviceOffer: "Service Offer",
    titleEn: "Offer Title in English",
    titleAr: "Offer Title in Arabic",
    descEn: "Offer Description in English",
    descAr: "Offer Description in Arabic",
    startDate: "Offer Start Date",
    endDate: "Offer End Date",
    carMakes: "Vehicle Brands",
    carTypes: "Vehicle Types",
    all: "All",
    pinToExplore: "Pin to Explore",
    addCTAButton: "Add CTA Button",
    ctaRedirectionPage: "CTA button’s redirection page",
    offerId: "Offer’s ID",
    redirectionURl: "Offer’s redirection URL",
    promocodesOfferId: "Promo codes offer id",
    ctaNameEn: "CTA button’s name in English",
    ctaNameAr: "CTA button’s name in Arabic",
    nationalIdVerificationRequired:"Requires National ID Verification",
    validation: {
      titleEnReq: "Offer title in english is required",
      titleEnValid: "Offer title in english doesn't allow arabic characters",
      titleEnMax:
        "Offer title in english must be less than or equal to 160 characters",
      titleArReq: "Offer title in arabic is required",
      titleArValid: "Offer title in arabic doesn't allow english characters",
      titleArMax:
        "Offer title in arabic must be less than or equal to 160 characters",
      descEnReq: "Offer description in english is required",
      descEnValid:
        "Offer description in english doesn't allow arabic characters",
      descEnMax:
        "Offer description in english must be less than or equal to 5000 characters",
      descArReq: "Offer description in arabic is required",
      descArValid:
        "Offer description in arabic doesn't allow english characters",
      descArMax:
        "Offer description in arabic must be less than or equal to 5000 characters",
      startDateReq: "Offer start date is required",
      endDateReq: "Offer end date is required",
      startDateMin: "Offer start date must be an upcoming date",
      endDateMin: "Offer end date must be after its start date",
      startDateType: "Offer start date must be a valid date",
      endDateType: "Offer end date must be a valid date",
      carMakesReq: "Choose at least one vehicle brand or you can choose all",
      carTypesReq: "Choose at least one vehicle type or you can choose all",
      bannerReq: "Offer banner is required",
      hotOfferBannerReq: "Hot offer banner is required",
      ctaRedirectionPageReq: "CTA button’s redirection page is required.",
      offerIdReq: "Offer’s ID is required",
      redirectionURlReq: "Offer’s redirection URL is required",
      redirectionURlValid: "Offer’s redirection URL is not valid",
      promocodesOfferIdReq: "Promo codes offer id is required",
      ctaNameTextOnly:
        " Invalid input: This field only accepts letters and special characters. Please remove any numbers and symbols.",
      ctaNameEnReq: "CTA button’s name in English is required",
      ctaNameEnValid:
        "CTA button’s name in English doesn't allow arabic characters and numbers",
      ctaNameEnMax:
        "CTA button’s name in English must be less than or equal to 30 characters",
      ctaNameArReq: "CTA button’s name in Arabic is required",
      ctaNameArValid:
        "CTA button’s name in Arabic doesn't allow english characters and numbers",
      ctaNameArMax:
        "CTA button’s name in Arabic must be less than or equal to 30 characters",
    },
  },
  offerDetails: {
    offerDetails: "Offer Details",
    published: "Published",
    unpublished: "Unpublished",
    serviceOffer: "Service Offer",
    serviceOfferMarked: "Offer marked as service offer",
    serviceOfferRemoved: "Service offer flag removed",
    publish: "Publish",
    unpublish: "Unpublish",
    all: "All",
    titleEn: "Offer Title in English",
    titleAr: "Offer Title in Arabic",
    descEn: "Offer Description in English",
    descAr: "Offer Description in Arabic",
    startDate: "Offer Start Date",
    endDate: "Offer End Date",
    carMakes: "Vehicle Brands",
    carTypes: "Vehicle Types",
    pending: "Pending",
    started: "Started",
    expired: "Expired",
    offerDates: "Offer Dates",
    theCtaButtonStatus: "The CTA button status",
    theCtaRedirectionPage: "The CTA redirection page",
    redirectionURl: "Offer’s redirection URL",
    loyalityOfferId: "Loyality Offer ID",
    promocodesOfferId: "Promo codes Offer ID",
    theCtaNameEn: "The CTA name in English",
    theCtaNameAr: "The CTA name in Arabic",
    hotOfferToggle: "Hot Offer",
    offerBanner:"Offer Banner",
    hotOfferBanner:"Hot offer Banner",
    hotOfferConfirm: "Marking this offer as hot will highlight it for users. Are you sure you want to mark this offer as a hot offer?",
    hotOfferRemoveConfirm: "Removing this offer from hot offers will remove its highlight. Are you sure you want to remove it?",
    hotOfferMark: "Mark as Hot Offer",
    hotOfferRemove: "Remove Hot Offer",
    hotOfferMarked: "Offer has been marked as hot successfully",
    hotOfferRemoved: "Offer has been removed from hot offers successfully",
    hotOfferDisabledTooltip: "This offer must be published before it can be flagged as a Hot Offer.",
    flagAsServicesOffer: "Flag as Services Offer",
    uploadHotOfferBanner: "Please upload a Hot Offer banner before activating this option.",
    nationalIdVerificationRequired: "Requires National ID Verification",
  },
};
